import { initTokatsu } from "./TokatsuSystem.js";
import { arrayToObject } from "./Common.js";


const cities = {
    "kashiwa": {
      "SJO": ["0244", "0401"],
      "PUB": ["0053"],
      "city":"千葉県柏市",
    },
    "matsudo": {
      "SJO": ["0298", "0296"],
      "PUB": ["0054"],
      "city":"千葉県松戸市",
    },
    "kamagaya": {
      "SJO": ["0403"],
      "PUB": ["0058"],
      "city":"千葉県鎌ケ谷市",
    },
    "ichikawa": {
      "SJO": ["0297"],
      "PUB": ["0056"],
      "city":"千葉県市川市",
    },
    "nagareyama": {
      "SJO": ["0300"],
      "PUB": ["0053"],
      "city":"千葉県流山市",
    },
    "noda": {
      "SJO": ["0361"],
      "PUB": ["0063", "0064"],
      "city":"千葉県野田市",
    },
    "abiko": {
      "SJO": ["0382"],
      "PUB": ["0053"],
      "city":"千葉県我孫子市",
    },
    "moriya": {
      "SJO": ["0299"],
      "PUB": ["0043"],
      "city":"茨城県守谷市",
    },
    "toride": {
      "SJO": ["0299"],
      "PUB": ["0043"],
      "city":"茨城県取手市",
    },
    "other": {
      "SJO": [],
      "PUB": [],
      "city":"その他",
    }
  }




export const TargetPrint = {
  props: {},
  async init(){
    console.log(`init TargetPrint`);

    this.props =  await initTokatsu();

    // 配列を参照用オブジェクトに変換
    this.props["SJOsRef"] = arrayToObject(this.props["SJOs"], `saijo_CD`);
    this.props["PUBsRef"] = arrayToObject(this.props["PUBs"], `saijo_CD`);
    document.querySelector(`[name="city"]`).innerHTML = Object.keys(cities).map(v=>{
      return `<option value="${v}">${cities[v].city}</option>`
    }).join(``);
    // セッションストレージからデータを取得
    const extractedContent = sessionStorage.getItem('extractedContent');
    if (extractedContent) {
      // JSON文字列をオブジェクトに変換
      const data = JSON.parse(extractedContent);
      console.log('data', data);
      // データを利用してDOM操作
      this.dataNames(data);
      document.getElementById(`plan-item-list`).innerHTML = this.itemLists(data);
      document.getElementById(`tag-includes`).innerHTML = this.tagLists(data);
      document.getElementById(`saidan`).innerHTML = `<img src="/assets/image/plan${data["FNP_CD"]}.webp" alt="" class="src">`;
      // その他のデータも使用可能
      document.querySelector('.btnApply').addEventListener('click', ()=> {
        const city = document.querySelector('select[name="city"]').value;
        this.btnApplyHandle(cities, city);
      });
    } else {
      console.log('No data found in sessionStorage');
    }

  },
  dataNames(data){
    const dataNames = document.querySelectorAll(`[data-name]`);
    dataNames.forEach((el) => {
      const name = el.getAttribute('data-name');
      if (data[name]) {
        el.innerHTML = data[name];
      }
    });
  },
  itemLists(data){
    return `${data["items"].map(v=>{
      return `<div class="modal-button" data-item="${v.item_CD}">
              <figure class="image-1by1">
                <img src="/assets/image/${v.item_CD}.webp" alt="" class="src">
              </figure>
              <p class="has-text-centered is-size-7">${v.item_name}</p>
            </div>`
    }).join(``)}`
  },
  tagLists(data){
    return `${data["tags"].map(v=>{
      return `<div><span class="tag">${v}</span></div>`
    }).join(``)}`
  },
  btnApplyHandle(cities,city){
    const props = this.props
    console.log('city', cities[city]);
    const SJOs = cities[city]["SJO"];
    const PUBs = cities[city]["PUB"];
    document.body.insertAdjacentHTML('beforeend', this.procSheets(SJOs, props["SJOsRef"],'SJO',cities[city]["city"]));
    document.body.insertAdjacentHTML('beforeend', this.procSheets(PUBs, props["PUBsRef"],'PUB',cities[city]["city"]));

    /**---------------------------------------------
     * memoの更新
    **-----------------------------------------------*/
    let memo = `式場：`;
    memo+=`${SJOs.map(v=>{
      const f = props["SJOsRef"][v];
      return `${f.SJO_name_HP}`
    }).join(`, `)}<br>火葬場：${PUBs.map(v=>{
      const f = props["PUBsRef"][v];
      return `${f.SJO_name_HP}`
    }).join(`, `)}<br>参列人数：<br>返礼品数：`;
    console.log(memo);
    document.getElementById(`memo`).innerHTML = memo;
  },
  procSheets(SJOs, Ref, attr,city){
    console.log(attr);
    const Sheets = document.querySelectorAll(`[data-attr="${attr}"]`);
    if (Sheets) {
      Sheets.forEach((el) => {
        el.remove();
      });
    }
    console.log('SJOs', SJOs);
    return `${SJOs.map(v=>{
      const f = Ref[v];
      const attrs = {
        "SJO":"にお住まいの方の『月のあかり 家族葬式場』",
        "PUB":"にお住まいの方の火葬場",
      }
      const cost = attr=="SJO"?`<tr><th>式場使用料金</th><td>無料</td></tr>`:``;
      return `<section class="sheet section py-5" data-attr="${attr}" style="display:flex;flex-direction:column;">
        <header class="is-flex is-justify-content-space-between is-align-items-center pb-2 mb-3" style="border-bottom:1px solid #d0d0d0;">
          <div>
            <figure class="image" style="width:30mm;">
              <img src="/assets/image/logo.svg" alt="" srcset="">
            </figure>
          </div>
          <div>
            <h2 class="title is-serif mb-0 is-5" style="letter-spacing:0.1em;">${city}${attrs[attr]}</h2>
          </div>
        </header>
        <div class="columns" style="flex:1">
          <div class="column">
            <figure class="image-2by3">
              <img src="/assets/image/${f.SJO_slug}.webp" alt="" class="src">
            </figure>
            <div class="pb-2 mb-4">
              <h2 class="title is-5 is-serif pt-4 pb-2 has-text-centered" style="letter-spacing:4px;border-bottom:1px solid #d0d0d0;">
                ${f.SJO_name_HP}
              </h2>
            </div>
            <div class="content is-small">
              <table class="table is-fullwidth">
                <tbody id="tbody-facility">
                  <tr>
                    <th>住所</th>
                    <td>${f.SJO_address01}${f.SJO_address02}${f.SJO_address03}</td>
                  </tr>
                  <tr>
                    <th>電話番号</th>
                    <td>0120-374-556</td>
                  </tr>
                  <tr>
                    <th>ご利用人数</th>
                    <td>～${f.SJO_seats_val}名</td>
                  </tr>
                  <tr>
                    <th>駐車場</th>
                    <td>${f.SJO_parking_val}台</td>
                  </tr>
                  ${cost}
                </tbody>
              </table>
            </div>
          </div>
          <div class="column">
            <figure class="image-2by3">
              <img src="/assets/image/${f.SJO_slug}01.webp" alt="" class="src">
            </figure>
            <div class="grid-container">
              <figure class="image-2by3">
                <img src="/assets/image/${f.SJO_slug}02.webp" alt="" class="src">
              </figure>
              <figure class="image-2by3">
                <img src="/assets/image/${f.SJO_slug}03.webp" alt="" class="src">
              </figure>
            </div>
          </div>
        </div>
      <footer class="is-flex is-justify-content-space-between is-align-items-center pt-2 pb-2" style="border-top:1px solid #d0d0d0;border-bottom:1px solid #d0d0d0;">
        <div class="is-flex is-align-items-center">
          <div>
            <p class="is-serif">私たちと一緒に、家族葬のこと考えてみませんか？<br>月のあかり家族葬ホールに加えて、提携式場や公営斎場でのお式も承ります。</p>
          </div>
        </div>
        <div class="is-flex is-align-items-center">
          <div class="mr-2">
            <p class="is-size-7 has-text-primary">総合受付</p>
            <figure style="width:48px;"><img src="/assets/image/freedial.svg"></figure>
          </div>
          <h2 class="subtitle mb-0 is-1 has-text-primary" style="letter-spacing:0;line-height:1;">0120-374-556</h2>
        </div>
      </footer>
    </section>`
    }).join(``)}`;
    }
}

// window.addEventListener('DOMContentLoaded', async function() {
//   await TargetPrint.init();

// })
